import React from "react";
import BannerRight from "./../../assets/images/banner_rgiht.png";
import BannerTop from "./../../assets/images/banner_top.png";
import Logo from "./../../assets/images/logo_light.png";
import Amzoon from "./../../assets/images/amazon.png";
import BannerImg from "./../../assets/images/banner_img.png";
import BannerImgMob from "./../../assets/images/banner_img_mob.png";
import "./banner.css";
const Banner = () => {
  const shopNow = () => {
    window.open(
      'https://a.co/d/1Tnoxt3',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  return (
    <div className="banner" id="shop">
      <div className="banner_left">
        <img src={BannerRight} alt="" className="banner_desktop" />
        <img src={BannerTop} alt="" className="banner_mobile" />
      </div>
      <div className="banner_right">
        <div>
          <img src={Logo} alt="" />
          <p className="banner_heading">
            Your Beauty Solution, Just a Click Away
          </p>
          <p className="banner_description">
            Shop Our Products on Amazon for Instant Glam!
          </p>
          <button className="primary_btn_light" onClick={()=>shopNow()}>Shop Now</button>
          <div style={{ margin: "20px 0" }}>
            <img src={Amzoon} alt="" />
          </div>
        </div>
        <div className="banner_img">
          <img src={BannerImg} alt=" " />
        </div>
        <div className="banner_mobile">
          <img src={BannerImgMob} alt=" " width='100%'/>
        </div>
      </div>
    </div>
  );
};

export default Banner;
